export enum DocumentStatus {
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  PENDING = "PENDING",
}

export enum DocumentType {
  ACCEPTANCE = "ACCEPTANCE",
  DISPATCH = "DISPATCH",
}

export interface DocumentsData {
  id: number;
  type: string;
  status: string;
  date: string;
  externalDocument: string;
  customerDisplayName: string;
  destinationDisplayName: string;
  address?: string;
  city?: string;
  province?: string;
  postalCode?: string;
  country?: string;
  phoneNumber?: string;
  carriageDescription?: string;
  shipmentCost?: number;
  shipmentSupplierCost?: number;
  products?: Array<any>;
}
